<div class="dashboard-section-header">
  <h2 *ngIf="title">{{title}}</h2>
  <app-search-filters dateLabel="Date Registered" type="generic" [(ngModel)]="searchOptions" class="ms-auto"></app-search-filters>
</div>
<!-- begin::Table container -->
<div class="table-responsive p-relative" *ngIf="($donors | async) && ($donors | async)?.length">
  <!-- begin::Table -->

  <div class="loading-container" *ngIf="$loading | async">
    <div class="p-relative w-100">
      <nz-spin nzTip="Loading..."></nz-spin>
    </div>
  </div>

  <table class="table align-middle gs-0 gy-4 donor-table">

    <thead>
      <tr>
        <th style="width:200px;">Donor ID</th>
        <th>Info</th>
        <th>Date Registered</th>
        <th>Actions</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let donor of $donors | async">
        <td>
          <p class="field-primary">ID: {{donor.id | slice: 0: 8}}...</p>
          <p class="field-secondary"><app-copy-button [content]="donor.id" [label]="'Full ID'"></app-copy-button></p>
        </td>
        <td>
          <ng-container *ngIf="donor">
            <div class="d-flex align-items-center">
              <div class="donor-icon">
                <i class="menuicon-success-1"></i>
              </div>
              <div class="text">
                <p class="field-primary" *ngIf="donor.first_name">{{donor.first_name}} {{donor.last_name}}</p>
                <p class="field-secondary" *ngIf="donor.first_name">{{donor.email}}</p>
                <p class="field-primary" *ngIf="!donor.first_name">{{donor.email}}</p>
              </div>
            </div>
          </ng-container>
        </td>
        <td>
          <p class="field-primary">{{donor.created_at | date: 'mediumDate'}}</p>
          <p class="field-secondary">{{donor.created_at | date: 'hh:mm:ss a'}}</p>
        </td>
        <td>
          <a class="btn btn-theme btn-sm" [routerLink]="'/donors/' + donor.id">View Donor</a>
        </td>
      </tr>
    </tbody>

  </table>

</div>

<div class="empty-state" *ngIf="!($loading | async) && ($donors | async) && !($donors | async)?.length">

  <h2>No Donors Found</h2>
  <p>Either there are no donors at all, or you need to adjust the filters.</p>

</div>

<div class="pagination-container mt-8 text-right" *ngIf="totalPages | async">
  <nz-pagination (nzPageIndexChange)="page = $event" [nzPageSize]="20" [nzPageIndex]="page" [nzTotal]="totalPages | async"></nz-pagination>
</div>

<ng-template
  #paymentTemplate
  let-payment="payment"
>
  <ng-container *ngIf="payment">
    <p class="field-primary">{{payment.amount / 100 | currency: payment.currency}}</p>
    <p class="field-secondary">{{payment.net / 100 | currency: payment.currency}}</p>
  </ng-container>
  <ng-container *ngIf="!payment">
    <p class="field-primary">--</p>
    <p class="field-secondary">--</p>
  </ng-container>

</ng-template>
